import { render } from "./InlineAvatar.vue?vue&type=template&id=7b4bea11"
import script from "./InlineAvatar.vue?vue&type=script&lang=js"
export * from "./InlineAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dalmatian2.reunionmarketing.com/dalmatian2.reunionmarketing.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__